// @core/api/endpoints/task/assign_task.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AssignTaskRequest,
  TaskResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Assign task
 * Assigns the task to an actor (user, bot, or team). The assignee receives a notification and the task appears in their task list.
 */
export async function AssignTask(
  task_id: string,
  data: AssignTaskRequest,
  options?: RequestOptions
): Promise<TaskResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/assign`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.post<TaskResponse>(requestPath, data, requestOptions);
}
